var $class="se2--header-se",$name="HeaderSE",$path="app/components/HeaderSE/config.js",$this={$class,$name,$path,};export const focusableElementsSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
export const headerClassName = $class;
export const headerSelector = `.${$class}`;
export const metabarHeightValue = 40;
